// extracted by mini-css-extract-plugin
module.exports = {"box-container":"Box_box-container__pbtwY"};